import { NetworkService } from '../services/NetworkService'

interface IOption {
  id: number
  optionTypeId: number
  optionType: string
  name: string
  number: string
  price: number

}

export class Option implements IOption {
  id!: number
  optionTypeId!: number
  optionType!: string
  name!: string
  number!: string
  price!: number

  constructor(params: IOption) {
    Object.assign(this, params)
    if (this.optionTypeId === 1) {
      this.optionType = "Colour"
    } else if (this.optionTypeId === 2) {
      this.optionType = "Test"
    }
  }

}
